import _ from "lodash";
import {
  Service,
  ServiceProfiles,
  ServicesActivationCommand,
  UserMode,
} from "@sportal/api";

import { getAccount, getAccountSettings } from "../root.selectors";
import { getSavedProfilesList } from "../profiles/profiles.selectors";
import { activationCommands } from "./activationCommands";
import { RootState } from "../root.reducer";
import { SERVICES } from "../../common/utils/permissions";

const getService = (serviceName) => (state) => getAccount(state)[serviceName];

export const getSBAccountService = (state) =>
  getService(Service.SecureBusiness)(state);

export const isAccountCreationFailed = (state) => {
  const { accountCreationFailed } = getAccount(state);

  return accountCreationFailed;
};

export const isSPSONAvailable = _.flow(
  getSBAccountService,
  (service) => service && service["spson-enabled"],
  Boolean
);

export const isMultipleUserLevel = (state) => {
  const service = getSBAccountService(state);

  return service && service.type === ServiceProfiles.SBMultiple;
};

export const isSBProvisionedWithoutProfiles = (state) => {
  const service = getSBAccountService(state);
  const profiles = getSavedProfilesList(state);

  return service && service.activated && profiles.length === 0;
};

export const is24HourFormat = _.flow(
  getAccountSettings,
  (accountSettings) => accountSettings.is24hourFormat
);
export const getTimeZone = _.flow(
  getAccountSettings,
  (accountSettings) => accountSettings.timezone
);

export const getActivationCommand = (
  state: RootState,
  isSingleProfile: boolean
): ServicesActivationCommand => {
  const isServiceActivated = (service) => service && service.activated;

  const userMode = isSingleProfile ? UserMode.SBSingle : UserMode.SBProfile;

  return activationCommands[userMode].filter(({ service: serviceName }) => {
    const service = getService(serviceName)(state);

    return !isServiceActivated(service);
  });
};

export const isUserLoggedIn = (state) => {
  const account = getAccount(state);

  return account?.id;
};

export const getSBEnabledStatus = (state: RootState): boolean => {
  const service = getSBAccountService(state);

  return service?.enabled;
};

export const getIsSubscriberActivated = (state: RootState): boolean => {
  const account = getAccount(state);

  return account[SERVICES.SB] && account[SERVICES.SB].activated;
};

export const getBusinessName = (state: RootState): string =>
  getAccountSettings(state).businessName;

export const isSpsonEnabled = (state) => state.account.isSpsonEnabled;
